import React, { useState, useEffect } from "react";
import { Popover, Select, Button, message } from "antd";
import { EditFilled } from '@ant-design/icons';

const { Option } = Select;

const VvDepartmentPopover = ({ itemId, onSave, currentDepartmentCode, currentDepartmentName, departmentOptions, isEditing = false, quantities = [] }) => {
    const [popoverVisible, setPopoverVisible] = useState(false);
    const [selectedDepartment, setSelectedDepartment] = useState("");
    const [loading, setLoading] = useState(false);

    const getQuantityForDepartment = (departmentCode) => {
        if (!quantities || !Array.isArray(quantities) || !departmentCode) {
            return null;
        }

        const departmentWithPrefix = `vv_${departmentCode.toLowerCase()}`;
        const quantityItem = quantities.find(q => q.supplier === departmentWithPrefix);

        return quantityItem ? quantityItem.quantity : null;
    };

    useEffect(() => {
        if (isEditing && currentDepartmentCode) {
            const matchingOption = departmentOptions.find(opt => opt.code === currentDepartmentCode);
            setSelectedDepartment(matchingOption?.value || "");
        } else if (!isEditing) {
            setSelectedDepartment("");
        }
    }, [isEditing, currentDepartmentCode, departmentOptions, popoverVisible]);

    const handleOpenChange = (open) => {
        setPopoverVisible(open);
        if (!open && isEditing && currentDepartmentCode) {
            const matchingOption = departmentOptions.find(opt => opt.code === currentDepartmentCode);
            setSelectedDepartment(matchingOption?.value || "");
        } else if (!open && !isEditing) {
            setSelectedDepartment("");
        }
    };

    const handleSave = async () => {
        if (!selectedDepartment) {
            message.error("Please select a department");
            return;
        }

        const selectedOption = departmentOptions.find(opt => opt.value === selectedDepartment);
        if (!selectedOption) {
            message.error("Invalid department selected");
            return;
        }

        const dept_code = selectedOption.code;
        const dept_name = selectedOption.value === '' ? '' : (selectedOption.label.split(' - ')[1] || selectedOption.label);

        setLoading(true);
        try {
            await onSave({
                itemId,
                department_code: dept_code,
                department_name: dept_name,
            });

            message.success("Department updated successfully");
            setPopoverVisible(false);
        } catch (error) {
            console.error("Error saving department:", error);
            message.error(error.response?.data?.message || "Failed to save department");
        } finally {
            setLoading(false);
        }
    };

    const content = (
        <div style={{ width: 300 }}>
            <div style={{ marginBottom: 8 }}>
                <label style={{ display: "block", marginBottom: 4, fontWeight: 500 }}>VV Department</label>
                <Select
                    value={selectedDepartment}
                    onChange={setSelectedDepartment}
                    placeholder="Select department"
                    style={{ width: "100%" }}
                    showSearch
                    filterOption={(input, option) => {
                        const searchText = input.toLowerCase();
                        const optionText = option.children.props.children[0].props.children.toLowerCase();
                        return optionText.indexOf(searchText) >= 0;
                    }}
                >
                    {departmentOptions.map((option) => {
                        const quantity = getQuantityForDepartment(option.code);
                        return (
                            <Option key={option.value} value={option.value}>
                                <div className="d-flex justify-content-between align-items-center">
                                    <span>{option.label}</span>
                                    {quantity !== null && (
                                        <span className="ml-2 text-muted" style={{ fontSize: '12px' }}>
                                            Stock: {quantity}
                                        </span>
                                    )}
                                </div>
                            </Option>
                        );
                    })}
                </Select>
            </div>
            <div style={{ textAlign: "right" }}>
                <Button
                    type="primary"
                    onClick={handleSave}
                    loading={loading}
                >
                    Save
                </Button>
            </div>
        </div>
    );

    return (
        <Popover
            content={content}
            title="Edit VV Department"
            open={popoverVisible}
            onOpenChange={handleOpenChange}
            trigger="click"
            placement="right"
        >
            <EditFilled
                style={{ color: "#fd7e14", cursor: "pointer", fontSize: "14px" }}
            />
        </Popover>
    );
};

export default VvDepartmentPopover; 